import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, Send } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-dark border-t border-white/5 mt-auto">
      <div className="container mx-auto px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8">
          {/* Logo ve Açıklama */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4 group">
              <div className="bg-primary text-primary-foreground p-2 rounded-md group-hover:shadow-[0_0_20px_rgba(0,229,153,0.4)] transition-all duration-300">
                <TrendingUp className="h-5 w-5" />
              </div>
              <span className="text-xl font-heading font-bold">
                <span className="text-white">Borsa</span>
                <span className="text-primary">mex</span>
              </span>
            </Link>
            <p className="text-sm text-slate-400 max-w-md mb-4">
              Kripto piyasasını takip etmek zor mu? Borsamex AI sizin için piyasayı analiz eder ve 
              en uygun zamanda AL, SAT veya BEKLE sinyalleri gönderir. Basit, anlaşılır, etkili.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.instagram.com/borsamex/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-pink-400 transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a
                href="https://t.me/BorsamexTR"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-blue-400 transition-colors"
                aria-label="Telegram"
                data-testid="footer-telegram"
              >
                <Send className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61585529325636"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-blue-500 transition-colors"
                aria-label="Facebook"
                data-testid="footer-facebook"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Ürün Linkleri */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm">Ürün</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/signals" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Sinyaller
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Fiyatlandırma
                </Link>
              </li>
              <li>
                <Link to="/nasil-calisir" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Nasıl Çalışır?
                </Link>
              </li>
              <li>
                <Link to="/referans-programi" className="text-sm text-slate-400 hover:text-primary transition-colors flex items-center gap-1">
                  Referans Programı
                  <span className="text-[10px] bg-primary/20 text-primary px-1.5 py-0.5 rounded">YENİ</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Rehber */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm">Rehber</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/rehber/kripto-sinyali-nedir" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Kripto Sinyali Nedir?
                </Link>
              </li>
              <li>
                <Link to="/rehber/rsi-nedir" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  RSI Nedir?
                </Link>
              </li>
              <li>
                <Link to="/rehber/macd-nedir" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  MACD Nedir?
                </Link>
              </li>
              <li>
                <Link to="/rehber/fibonacci-nedir" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Fibonacci Nedir?
                </Link>
              </li>
              <li>
                <Link to="/rehber/destek-direnc-nedir" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Destek ve Direnç
                </Link>
              </li>
              <li>
                <Link to="/rehber/long-nedir" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Long Nedir?
                </Link>
              </li>
              <li>
                <Link to="/rehber/futures-trading-nedir" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Futures Trading
                </Link>
              </li>
              <li>
                <Link to="/rehber" className="text-sm text-primary hover:text-primary/80 transition-colors">
                  Tüm Rehberler →
                </Link>
              </li>
            </ul>
          </div>

          {/* Kurumsal */}
          <div>
            <h3 className="text-white font-semibold mb-3 text-sm">Kurumsal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/kurumsal/hakkimizda" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/kurumsal/is-birlikleri" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  Stratejik İş Birlikleri
                </Link>
              </li>
              <li>
                <Link to="/kurumsal/iletisim" className="text-sm text-slate-400 hover:text-primary transition-colors">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Hukuki Uyum Etiketi */}
        <div className="pt-6 border-t border-white/5">
          <p className="text-xs text-slate-500 text-center leading-relaxed max-w-5xl mx-auto">
            <span className="text-amber-500/80">⚠️ Yasal Uyarı:</span> Borsamex, yatırımcılar için genel nitelikli teknik analiz ve sinyal üreten bir teknoloji platformudur. Platformumuz portföy yönetimi veya yatırım danışmanlığı hizmeti sunmaz. Sunulan içerikler kişiye özel değildir ve yatırım tavsiyesi niteliği taşımaz. Borsalara herhangi bir şekilde emir iletimi veya otomatik işlem yapılmaz. Yatırım kararları ve doğabilecek riskler tamamen kullanıcıya aittir.
          </p>
        </div>

        {/* Alt Bölüm - Copyright ve Yasal Linkler */}
        <div className="pt-6 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-xs text-slate-500">
              © {currentYear} Borsamex. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center flex-wrap gap-x-6 gap-y-2">
              <Link to="/legal/privacy" className="text-xs text-slate-500 hover:text-primary transition-colors">
                Gizlilik Politikası
              </Link>
              <Link to="/legal/terms" className="text-xs text-slate-500 hover:text-primary transition-colors">
                Kullanım Koşulları
              </Link>
              <Link to="/legal/risk" className="text-xs text-slate-500 hover:text-primary transition-colors">
                Risk Bildirimi
              </Link>
              <Link to="/legal/cookies" className="text-xs text-slate-500 hover:text-primary transition-colors">
                Çerez Politikası
              </Link>
            </div>
          </div>
        </div>

        {/* Engineered By - Subtle Credit */}
        <div className="pt-4 text-center">
          <a 
            href="https://datexsystems.com/systems" 
            target="_blank" 
            rel="noopener"
            className="group transition-colors"
            style={{ 
              fontSize: '12px', 
              fontWeight: 500, 
              letterSpacing: '0.03em',
              textDecoration: 'none'
            }}
          >
            <span style={{ color: 'rgba(255,255,255,0.42)' }} className="group-hover:text-slate-300 transition-colors">
              Engineered by{' '}
            </span>
            <span 
              style={{ color: 'rgba(20,184,166,0.65)' }} 
              className="group-hover:text-teal-400 transition-colors"
            >
              Datex Systems
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
